<script>
export default {
  props: ['entityCode', 'entityId', 'value'],
  beforeMount () {
    this.$store.dispatch('crossRelations/load', { entityCode: this.entityCode, entityId: this.entityId })
  },
  computed: {
    entityRelations () {
      return this.$store.getters['crossRelations/getRelations'](this.entityCode, this.entityId)
    },
    loading () {
      return !this.entityRelations
    }
  },
  render () {
    this.$emit('input', this.entityRelations)
    return this.$scopedSlots.default({
      loading: this.loading
      // errors: errors
    })
  }
}
</script>
